export default [
  {
    title: '2024, Minister of Trade, Industry and Energy Prize at Korea Green Building Award',
    date: 'NOVEMBER 2024',
    desc:
      'DATA CENTER GAK Sejong was named the winner of the Minister of Trade, Industry and Energy Award for its contribution to carbon reduction, including sustainability-based design and building eco-friendly facilities.'
  },
  {
    title: 'ISO 14001 Environmental <br />Management System <br />certification obtained',
    date: 'JULY 2021',
    desc:
      "We've built an environmental management system by obtaining ISO 14001 certification, and actively develop and implement operational policies that help reduce environmental impacts across greenhouse gas, energy, water, and waste."
  },
  {
    title: "2018, Korea Energy <br />Agency selected as <br />Korea's Energy Champion",
    date: 'NOVEMBER 2018',
    desc:
      'We have been selected as an Energy Champion in 2018 as well as 2017 for our ongoing efforts for eco-friendliness including energy saving, greenhouse gas emission reductions, and water recycling.'
  },
  {
    title: '2018, Climate Change <br />Center Won the 8th <br />Grand Leaders Award <br />for Climate Change',
    date: 'NOVEMBER 2018',
    desc:
      'We&#039;ve saved electrical energy and reduced greenhouse gas by installing LED lighting and solar power systems in the data center "GAK" buildings, and got rewarded extra points for greening the roof and restoring greenery using eco-mats in the data center site.'
  },
  {
    title: '2017, Korea Energy <br />Agency Selected as <br />Korea&#039;s Energy Champion',
    date: 'NOVEMBER 2017',
    desc:
      'We&#039;ve been selected as Energy Champion as our efficient data center operation was recognized including snow melting, solar power generation using the sun ray and heat, and utilization of the natural cooling system through external air.'
  },
  {
    title: 'Selected in Top 10 most <br />beautiful data centers',
    date: 'JUNE 2017',
    desc:
      'We&#039;ve been selected as one of the top 10 most beautiful data centers in the world by "DatacenterDynamics," a specialist IT publication in the UK, with the comment that the eco-friendly design technology and the spiritual inheritance of "Janggyeonggak" where Tripitaka Koreana is stored are outstanding.'
  },
  {
    title: '2016 Climate week Merit <br />award for climate <br />change response and <br />greenhouse gas reduction',
    date: 'NOVEMBER 2016',
    desc:
      'We&#039;ve received a meritorious award for building a highly efficient eco-friendly data center, contributing to spreading eco-friendly values, and expanding green R&D investments at "Climate Week 2016" hosted by the Ministry of Trade, Industry and Energy.'
  },
  {
    title: '2015, the 7th Artificial <br />Ground Greening Award, <br />Grand Prize',
    date: 'OCTORBER 2015',
    desc:
      'We won the Grand Prize by winning extra points in greening the roof and hills on site resulting in a total 10,000 ㎡ of green roof space as well as pre-cultivating and planting Chuncheon&#039;s native plants. (jointly awarded with Connect One)'
  },
  {
    title: '2014, Korea Architecture <br />Awards Excellence Award',
    date: 'NOVEMBER 2014',
    desc:
      'We won an Excellence Award at Korea Architecture Awards that looks for buildings that are in harmony with their environments and have authenticity and modernity of the Korean architecture embodied. Extra points have been awarded for the buildings with the shape of rice terraces, louvers with the natural colors, and the eco-trail on the roof the server wing.'
  }
];
